import clsx from 'clsx';

import Image from '../Image';

import styles from './Icons.module.css';
import { KeyboardUpIconProps } from './types';

const KeyboardArrowUpIcon = ({ className }: KeyboardUpIconProps) => {
  const keyboardUpClassNames = clsx(styles.keyboardUpIcon, className);
  return (
    <Image
      src={'/marketplace-static/images/icons/arrowUpIcon.svg'}
      alt="arrow"
      width={30}
      height={30}
      className={keyboardUpClassNames}
    />
  );
};

export default KeyboardArrowUpIcon;
